<div class='treeview-header sticky'>
  <span class='product-name'>
    {{data.product}}
  </span>
  <!--Table Header-->
  <div #data_row class='data-row '>
    <div class='data-field antal-header'>{{data.number}}</div>
    <div class='data-field abb-header'>{{data.abb}}</div>
    <div class='data-field arno-header'>{{data.arrangementNumber}}</div>
    <div class='data-field copy-btn-header'></div>
    <div class='data-field saldo-header'>{{data.totalAmount}}</div>
    <div class='data-field bank-header'>{{data.bankCode}}</div>
    <div class='data-field specifics-header'>{{data.specifics}}</div>
    <div class='data-field status-header'>{{data.status}}</div>
    <div class='data-field relation-header'>{{data.relation}}</div>

    <div class="header-controls">
      <span (click)="expandOrCollapseAll()" class='clickable'>
        <sfc-icon name="{{allExpanded ? 'rds-icon-chevron-down' : 'rds-icon-chevron-right'}}"
                  class='expand-all-button'
                  size="xs"></sfc-icon>
        <span>Open alles</span>
      </span>
      <div class='data-field saldo'>{{data.activeFilter}}
        <label class="switch">
          <input type="checkbox" [(ngModel)]="isActiveProductsFilterEnabled">
          <span id='active-products-toggle' class="slider round"></span>
        </label>
      </div>
      <div class='data-field saldo'>{{data.saldoToggle}}
        <label class="switch">
          <input type="checkbox" [checked]="toggleState">
          <span id='balance-toggle' class="slider round" (click)="toggleBalance()"></span>
        </label>
      </div>
    </div>

  </div>
</div>
<app-toaster-container (styleEmitter)="updateToasterStyle()" [ngClass]="{'centered-toaster': centeredToaster}"></app-toaster-container>
<div id="hover-div"></div>
<div class='treeview-data'>
  <ng-container #po_node [appExpandAll]="allExpanded" [hostComponent]="this"></ng-container>
</div>
<mat-progress-bar mode="indeterminate" *ngIf="isWaiting"></mat-progress-bar>
<app-detail-screen #mainDetailsScreen></app-detail-screen>
<app-detail-screen #secondDetailsScreen class="second-detail-screen"></app-detail-screen>




